import { IJwtPayload } from "./commonClasses";

declare var angular: any;

interface ILang {
    code: string;
    descriptionKey: string;
}

module GlobalApplicationData {
    const SUPPORTED_LANGS: Array<string> = ["it", "en", "de"];

    angular.module("AdeMesApp").factory("GlobalApplicationData", [() => {
        let GlobalApplicationData = {
            //applicationContext: "/bin/",
            //applicationContext: "http://192.168.30.119:8080/Adesuite/rest/service/ademes/",
            //applicationContext: "https://pro.adesuite.com/app/rest/service/ademes/",
            //applicationContext: "https://pro.adesuite.com/app/rest/service/maccatrozzo/",
            //applicationContext: "https://pro.adesuite.com/app/rest/service/crivellari/",
            //applicationContext: "/crivellari_mes/",
            //applicationContext: "https://pro.adesuite.com/app/",
            //applicationContext:"https://192.168.1.12:90/adesuite/rest/service/ademes/",
            //applicationContext:"http://192.168.30.5/maccatrozzo/rest/service/ademes/",
            //applicationContext:"http://192.168.30.5/nep/rest/service/ademes/",



            //PER LA PRODUZIONE
            //applicationContext: "https://pro.adesuite.com/ademes/",

            //PER IL LOCALE
            //applicationContext: "http://localhost:8090/app/rest/service/ademes/",

            //PER TEST
            applicationContext: "https://test.adesuite.com/ademes/",



            // Indica la pagina originariamente richiesta dall'utente che ha scatenato l'autenticazione
            orginalRequestedURL: <string>null,

            // Variabile che contiene il token di autenticazione
            identityToken: <string>null,

            // Informazioni aggiuntive legate al token di autenticazione
            jwtPayload: <IJwtPayload>null,

            // Definisco l'array che conterrà tutte le possibili azioni a cui un utente è abilitato
            auths: <Array<string>>[],

            // Definisco l'array per le lingue disponibili nell'applicazione che sarà popolato da authenticatingCtrl
            // L'attributo mandatory indica che è obbilgatoria e di default (infatti deve sempre essercene solo una di mandatory)
            langs: <Array<ILang>>[]
        };

        SUPPORTED_LANGS.forEach(lang => {
            GlobalApplicationData.langs.push({
                code: lang,
                descriptionKey: "generic.langs." + lang
            });
        });

        return GlobalApplicationData;
    }])
};